import RootStore from "./stores/RootStore";
import rootStoreConfig from "./rootStoreConfig";

interface Window {
  rootStore?: RootStore;
  dateFNS?: unknown;
  __STORE_COUNT__?: number;
  __MEMORY_MONITOR__?: unknown;
}

export function createRootStore(): RootStore {
  const rootStore = new RootStore(rootStoreConfig);

  // if (import.meta.env.MODE === "development") {
  (window as Window).rootStore = rootStore;
  // }

  return rootStore;
}
